<template>
     <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'Menu'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">Proceso Competitivo 2025</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- AREA DE ARCHIVOS -->
                    <a :href="urlServe+'rendicion-ctas/proceso-competi/1-Bases-LP.pdf'" target="_blank">
                      
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Bases de Licitación Pública </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>       
                    <a :href="urlServe+'rendicion-ctas/proceso-competi/2-Anexo-A.pdf'" target="_blank">                     
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5>Bases de Licitación Pública - Anexo A</h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a :href="urlServe+'rendicion-ctas/proceso-competi/3-Anexo-B.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Bases de Licitación Pública - Anexo B </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <a :href="urlServe+'rendicion-ctas/proceso-competi/4-Anexo-C.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Bases de Licitación Pública - Anexo C </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <a :href="urlServe+'rendicion-ctas/proceso-competi/5-Anexo-D.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Bases de Licitación Pública - Anexo D </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <a :href="urlServe+'rendicion-ctas/proceso-competi/6-Convocatoria.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Convocatoria de Licitación Pública 01/2025, Refinanciamiento de la Deuda Pública para el Estado de Chiapas</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>   
                <a :href="urlServe+'rendicion-ctas/proceso-competi/7-Nota-Informativa.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Nota Informativa al Proceso de Licitación Pública No. 01/2025</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>     
                <a :href="urlServe+'rendicion-ctas/proceso-competi/8-Acta-Junta.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Acta de Junta de Aclaraciones</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <!--<h6 class="subtitulo mb-2">Proceso de Contratación de Deuda Pública 2025</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                   
                    <a :href="urlServe+'rendicion-ctas/PCDP/tercer-proc.pdf'" target="_blank">
                      
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Tercer Proceso </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a> -->

                </div>
                
                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes">
                        <div class="sec_imagen"> 
                            <img src="@/assets/imagenes/PC-2025.jpg" alt="">  
                        </div>
                    </div>
                    
                </div>
            </div>
            <!--<div class="text-aviso my-5">
                <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
            </div>-->
        </div>
    </div>
  </template>
  <script>
  import mapFun from '@/common/map-fn-types.js';
  import RendicionDeCuentas from "@/services/rendicionDeCuentas/rendicionDeCuentas.js";
  const _serviciosRendicionC = new RendicionDeCuentas();
  import cardsArray from '../../components/cardsArray.vue';
  import cardsMenu from '../../components/cardsMenu.vue';
  import botonAtras from './../button-atras'
  import DateFormat from "@/mixins/dateFormatMixin.js";
  
  export default {
    components: { cardsMenu, cardsArray, botonAtras},
    data() {
          return {
              data: [],
              error: '', // Maneja mensajes de error
              loading: true, // Indicador de carga
              fecha_actualizacion:''
          };
      },
      async created() {
          await this.getMenuRendicionCuentas();
      },
      mixins: [DateFormat],
      methods: {
        routeo(n){
            switch(n) {
              case 1: return "Presupuesto-de-Egresos";
              case 2: return "Finanzas-publicas";
              case 3: return "Gestion-financiera" //  /Gestion-financiera;
              case 4: return "Recursos-a-Municipios"
              case 5: return "Estrategico-institucional-org-pub"
              case 6: return "Cuentas-Publicas"; //Cuentas-Publicas
              case 7: return "Trimestral-publicas"; //Trimestral-publicas
              case 8: return "Presup-egres-org-pub";
              default: break;
            }
          },
          /*routeo(n){
            switch(n) {
              case 1: return "Presupuesto-de-Egresos";
              case 2: return "Finanzas-publicas";
              case 3: return "Gestion-financiera";
              case 4: return "Recursos-a-Municipios";
              case 5: return "Estrategico-institucional-org-pub";
              case 6: return "Cuentas-Publicas";
              case 7: return "Trimestral-publicas";
              case 8: return "Presup-egres-org-pub";
              default: break;
            }
          },*/
          async getMenuRendicionCuentas() {
              try {
                  const response = await _serviciosRendicionC.getMenuRendicionCtas(mapFun.rendicionCtasMenu);
                  this.data = response.data;
                  let fecha_texto = this.data[this.data.length - 1].fecha_actualizacion;
                  this.fecha_actualizacion = this.DateFormatText(fecha_texto);
              } catch (error) {
                  console.log('error', error.message);
              }
          }
      }
  }
  </script>
  <style scoped>
  .title_document { 
      padding: .8rem 1rem;             
      width: 100%;
      height: auto;
      border: 1px solid#dfdfdf ;
      border-radius: 5px;
      border-left: 3px solid #621132;

      display: flex;
      justify-content: space-between;
      align-items: center !important;
  } 

  .title_document:hover{
      box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
  }

  .descargar{
      font-size: 0.9rem;
      color: #6c757d !important;
  }

  .subtitulo {
      font-weight: 400;
      font-size: 1.8rem;
      margin-top: 1rem;
  }
  .subtitulo2{
      font-weight: 400;
      font-size: 1.2rem;
      margin-top: .5rem;
      margin-bottom: 1rem ;
  }
  .title_document h5{
      font-size: 0.9rem;
      font-weight: 400;
      /* line-height: 20px; */
  }

  .sec_imagen{ 
      width:85% !important;
      background-color: #560F2C;
      /* margin-top: 3rem; */
  }

  a{
      text-decoration: none !important;
      color: #212529;
  }
  a:hover{ color:#212529 !important; }

  /* margenes de la card consulta */
  .margenes{
      display: flex;
      justify-content: flex-end;
  }
  .card-width{ width: 90%; }
  
  /* select */
  .form-control-lg {
      font-size: 1rem;
      border-radius: .4rem;
  }

@media only screen and (max-device-width : 900px) {
  .container{
      padding-right: 1% !important;
      padding-left: 1% !important;
  }
  .title_document{
      padding: .5rem 1rem .5rem .1rem;
      line-height: 20px;
  }

  /* margenes de la card consulta */
  .margenes{ justify-content: space-around; }
  .card-width{ width: 95%; }

  .subtitulo2{ font-size: 1rem; }

  .sec_imagen{ margin-top: 0rem; }
}

</style>
  